<template>
  <div class="component-wrapper">
    <div class="text-h6 text-center mb-6">Users</div>

    <v-btn depressed color="primary">New User</v-btn>

    <v-data-table
      :headers="headers"
      :items="desserts"
      :items-per-page="10"
      dark
    ></v-data-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: "First Name",
          value: "firstName",
        },
        {
          text: "Last Name",
          value: "lastName",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Date Created",
          value: "createdDate",
        },
      ],
      desserts: [
        {
          firstName: "Jamal ",
          lastName: "Kerry",
          email: "jama.ke@gmail.com",
          createdDate: "05/06/2022",
        },
        {
          firstName: "Joo-Chan ",
          lastName: "Royster",
          email: "jama.ke@gmail.com",
          createdDate: "05/06/2022",
        },
        {
          firstName: "Jamal ",
          lastName: "Kerry",
          email: "o_roy@gmail.com",
          createdDate: "05/06/2022",
        },
        {
          firstName: "Bogdan ",
          lastName: "Royster",
          email: "bogdaroy@gmail.com",
          createdDate: "05/06/2022",
        },
        {
          firstName: "Maxime ",
          lastName: "Hadaway",
          email: "maximhada@gmail.com",
          createdDate: "05/06/2022",
        },
        {
          firstName: "Szabolcs ",
          lastName: "Cook",
          email: "sza_coo@gmail.com",
          createdDate: "05/06/2022",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>